
function voeg_reservering_toe(th) 
{
  var k = $(th).data('kind')
  var o = $(th).data('ouder')

  var d = $("#nieuw_" + o + "_" + k)

  var c = $("#col_" + o + "_" + k)

  var b = d.html().replace("NEGEER", "nieuw")

  var n = $("#nieuw")
  var nn = n.data("nieuw")
  n.data("nieuw", nn + 1) 

  var nnn = "n" + nn

  var g = d.html()
  var gg = g.replace("NUMMER", nnn)
  while (g != gg) {
    g = gg
    gg = g.replace("NUMMER", nnn)   
  }

  c.append(gg.replace("NEGEER", "nieuw"))

  $(".resdel").click(function() { verwijder_reservering(this) });
}

function verwijder_reservering(th)
{
   var p = $(th).closest("table")
   p.hide();

   var g = p.find("input")

   p.find("input").each(function() { $(this).val("del") } );

}


$(document).ready(function(){
   // .plusdefault is already hidden via CSS
   $(".resplus").click(function(){
     voeg_reservering_toe(this);
   });

   $(".resdel").click(function(){
     verwijder_reservering(this)
   });
});



